import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import React, { useEffect, useState } from "react";
import { FaChevronDown } from "react-icons/fa";
import { RxCross2 } from "react-icons/rx";
import { GrClose } from "react-icons/gr";
import { Link } from "react-router-dom";
import CountryAutoComplete from "../../comps/CountryAutoComplete";
import "./vessains.scss";
import dayjs from "dayjs";
import axios from "axios";
import toast from "react-hot-toast";

const Insurance = (props) => {
  const [depDate, setDepDate] = useState(false);
  const [destinationOpen, setDestinationOpen] = useState(false);
  const [countryOpen, setCountryOpen] = useState(false);
  const [peopleOpen, setPeopleOpen] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState("India");
  const [selectedDate, setSelectedDate] = useState(null);
const [loader,setLoader] = useState(false)
  const [modal, setModal] = useState(false);

  const toggleModal = () => {
    setModal(!modal);
  };

  const closeAllDropdowns = () => {
    setDestinationOpen(false);
    setCountryOpen(false);
    setPeopleOpen(false);
  };

  const [trip, setTrip] = useState({
    oneWay: true,
    returnTrip: false,
    multiCity: false,
  });

  const closeAllTrip = () => {
    setTrip({
      oneWay: true,
      returnTrip: true,
      multiCity: true,
    });
  };
  const [flight, setflight] = useState({
    depDate: false,
    travelClass: false,
    returnDate: false,
  });
  // closing all flight states
  const closeAll = () => {
    setflight({
      depDate: false,
      travelClass: false,
      returnDate: false,
    });
  };

  const handleCountrySelect = (value) => {
    setSelectedCountry(value.name);
  };
  const adults = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"];
  const children = ["0", "1", "2", "3", "4", "5", "6", "7"];
  const infants = ["0", "1", "2", "3", "4", "5", "6", "7"];
  const travelclass = [
    "Economy/Premium Economy",
    "Premium Economy",
    "Business",
  ];
  const handleSeatClick = (value) => {
    setFormData({ ...formData, adults_no: value });
  };
  const handlechildClick = (value) => {
    setFormData({ ...formData, kids_no: value });
  };
  const handleinfantClick = (value) => {
    setFormData({ ...formData, infants: value });
  };
  const handleclassClick = (value) => {
    setFormData({ ...formData, travel_class: value });
  };

  // handling date
  const formatISODate = (isoString) => {
    const date = new Date(isoString);
    if (isNaN(date.getTime()))
      return { day: "", month: "", year: "", weekday: "" };
    const day = date.getDate();
    const month = date.getMonth();
    const year = date.getFullYear();
    const weekday = date.getDay();

    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const weekdays = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];

    return `${day < 10 ? `0${day}` : day} ${months[month]} ${year} (${
      weekdays[weekday]
    })`;
  };

  const formatCurrentDate = () => {
    const date = new Date();
    const day = date.getDate();
    const optionsMonthYear = { month: "short", year: "numeric" };
    const monthYear = new Intl.DateTimeFormat("en-US", optionsMonthYear).format(
      date
    );
    const optionsDayOfWeek = { weekday: "long" };
    const dayOfWeek = new Intl.DateTimeFormat("en-US", optionsDayOfWeek).format(
      date
    );
    return `${day} ${monthYear} (${dayOfWeek})`;
  };
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    message: "",
    durationFrom: "",
    durationTo: "",
    destination: selectedCountry,
    dateOfTravel: formatCurrentDate() || "",
  });
  const handleDateChange = (newDate) => {
    const formattedDate = formatISODate(newDate);
    setSelectedDate(newDate);
    setFormData((prevData) => ({
      ...prevData,
      dateOfTravel: formattedDate,
    }));
  };

  useEffect(() => {
    setFormData({
      ...formData,
      destination: selectedCountry,
    });
  }, [selectedCountry]);


  const handleformSubmit = async () => {
    try {
      props.setLoader(true)
      const response = await axios.post(
        `${process.env.REACT_APP_URL}insurance/addInsurance`,
        formData
      );
 
      toast.success("Message submitted.");
      setFormData({
        name: "",
        email: "",
        phoneNumber: "",
        message: "",
        durationFrom: "",
        durationTo: "",
        destination: "",
        // date_of_travel: formatCurrentDate() || "",
      });
      setModal(false);
    } catch (err) {
      console.log(err);
    }finally{
      props.setLoader(false)
    }
  };


  return (
    <>
      <div className="form">
        <form action="" className=" form22">
          <div className="middle-form" id="oneway">
            {/* Destination Field */}
            <div
              className="from from-div"
              onClick={() => {
                closeAllDropdowns();
                setDestinationOpen(!destinationOpen);
              }}
            >
              <h3>Destination</h3>
              <p className="place-tag">{selectedCountry}</p>
              {destinationOpen && (
                <div
                  className="autocomplete"
                  onBlur={() => setDestinationOpen(false)}
                >
                  <CountryAutoComplete
                    placeholder="Select country"
                    close={() => setDestinationOpen(false)}
                    onSelectCountry={handleCountrySelect}
                  />
                </div>
              )}
            </div>

            {/* Date of Travel Field */}
            <div
              className="from departure"
              onClick={() => setDepDate(true)}
              onMouseLeave={() => setDepDate(false)}
            >
              <p className="top-tag">Date of Travel</p>
              <h4>{formData.dateOfTravel}</h4>
              {depDate && (
                <div className="calender-box">
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DateCalendar
                      className="calender"
                      onChange={handleDateChange}
                      value={selectedDate}
                      minDate={dayjs()}
                    />
                  </LocalizationProvider>
                </div>
              )}
            </div>

            {/* Number of People Field */}
            <div
              className="from travellersclass"
              onClick={() => {
                // closeAll();
                setflight((element) => ({
                  ...element,
                  travelClass: true,
                }));
              }}
            >

        
                <span className="top-tag">Travel Duration</span>

              <p>
                Duration From : <span>{formData.durationFrom || "DD-MM-YYYY"}</span>
              </p>
              <p>
                Duration To : <span>{formData.durationTo || "DD-MM-YYYY"}</span>
              </p>
              {flight.travelClass && (
                <div
                  className="travle-class insurance_pop"
                  onMouseLeave={(prev) =>
                    setflight({ ...prev, travelClass: false })
                  }
                >
                  <div class="durationTo">
                    <label for="">Start Date Of Duration</label>
                    <input value={formData.durationFrom} onChange={(e)=>setFormData({...formData,durationFrom:e.target.value})} type="date" />
                  </div>
                  <div class="durationTo">
                    <label for="">End Date Of Duration</label>
                    <input value={formData.durationTo} onChange={(e)=>setFormData({...formData,durationTo:e.target.value})} type="date" />
                  </div>
                </div>
              )}
            </div>
          </div>
          <Link className="btn" onClick={toggleModal}>
            Enquire Now
          </Link>
        </form>
      </div>

      {modal && (
        <>
          <div className="popup-parent parent">
            <div className="popup-cont container">
              <div className="close-pop" onClick={() => setModal(false)}>
                <GrClose />
              </div>
              <div className="contact-form">
                <h2 className="contact-heading">Enquire Now</h2>

                <div className="input-div">
                  <input
                    type="text"
                    name="Name"
                    placeholder="Name"
                    onChange={(e) =>
                      setFormData({ ...formData, name: e.target.value })
                    }
                  />
                </div>
                <div className="input-div">
                  <input
                    type="email"
                    name="Email"
                    placeholder="Email Id "
                    onChange={(e) =>
                      setFormData({ ...formData, email: e.target.value })
                    }
                  />
                </div>
                <div className="input-div">
                  <input
                    type="text"
                    name="phoneNumber"
                    placeholder="Mobile Number"
                    onChange={(e) =>
                      setFormData({ ...formData, phoneNumber: e.target.value })
                    }
                  />
                </div>
                <div className="input-div">
                  <textarea
                    name="Message"
                    cols="46"
                    rows="3"
                    placeholder="Message"
                    onChange={(e) =>
                      setFormData({ ...formData, message: e.target.value })
                    }
                  ></textarea>
                </div>
                <div className="btn-div">
                  <button
                    type="submit"
                    disabled={loader}
                    className="btn"
                    onClick={handleformSubmit}
                  >
                    {
                      loader ? "Submitting...." : "Submit"
                    }
                    
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Insurance;
